'use client';

import { usePathname } from 'next/navigation';
import { ReactNode, useRef } from 'react';
import { cn } from '@utils/cn';
import { ownsMobileScrollRegion } from '@utils/route-utils';
import { useMobileChromeScroll } from '../navigation/use-mobile-chrome-scroll';

interface MobileScrollViewProps {
  children: ReactNode;
  className?: string;
}

/**
 * The single vertical scroller on mobile. `overscroll-y-contain` stops
 * pull-to-refresh/rubber-banding from moving the whole document (the browser
 * chrome), which is the #1 "this is a website" tell in standalone mode.
 * On `lg+` it is `display: contents` — the document scrolls as before.
 */
export function MobileScrollView({
  children,
  className
}: MobileScrollViewProps) {
  const ownsScroll = ownsMobileScrollRegion(usePathname());
  const ref = useRef<HTMLDivElement>(null);
  useMobileChromeScroll(ref);
  return (
    <div
      ref={ref}
      data-mobile-scroll-view=""
      className={cn(
        'min-h-0 flex-1 overflow-y-auto overflow-x-clip overscroll-y-contain [-webkit-overflow-scrolling:touch] lg:contents',
        ownsScroll && 'flex flex-col overflow-hidden',
        className
      )}
    >
      {children}
    </div>
  );
}
